import { Routes } from '@angular/router';
import { LoginComponent } from './features/authentication/components/login/login.component';
import { CustomerComponent } from './features/customer/components/customer.component';
import { NavigationComponent } from './features/navigation/components/navigation.component';
import { LocationComponent } from './features/location/components/location.component';
import { CategoriesComponent } from './features/category/components/categories.component';
import { EmployeesComponent } from './features/employee/components/employees.component';
import { GroupSeriesComponent } from './features/group-series/components/group-series.component';
import { AdminsComponent } from './features/admin/components/admins.component';
import { SetPasswordComponent } from './features/authentication/components/set-password/set-password.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'set-password', component: SetPasswordComponent },
  {
    path: '',
    component: NavigationComponent,
    children: [
      { path: 'customer', component: CustomerComponent },
      { path: 'locations', component: LocationComponent },
      { path: 'categories', component: CategoriesComponent },
      { path: 'employees', component: EmployeesComponent },
      { path: 'group-series', component: GroupSeriesComponent },
      { path: 'admins', component: AdminsComponent },
      { path: '**', redirectTo: 'customer' }
    ]
  }
];
